import { EPaymentType } from "../../Enum/EPaymentType"

const fiscalPaymentTypes: EPaymentType[] = [
  EPaymentType.Cash,
  EPaymentType.Pix,
  EPaymentType.Card,
  EPaymentType.CreditCard,
  EPaymentType.DebitCard,
  EPaymentType.FoodVoucher,
  EPaymentType.MealVoucher,
  EPaymentType.TapToPay,
  EPaymentType.Other,
]

export const getFiscalPaymentTypeOptions = () =>
  fiscalPaymentTypes.map((paymentType) => ({
    value: paymentType.toString(),
    label: paymentType.toPaymentTypeString(),
  }))
